import { render, staticRenderFns } from "./GalleryFilterDefaultLayout.vue?vue&type=template&id=488f6834&scoped=true"
import script from "./GalleryFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./GalleryFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f6834",
  null
  
)

export default component.exports